import React, { ReactElement } from 'react'

import { Color } from '../../../../enums/color'
import { Icon } from '../../../Icon'
import { getIconSize } from '../../utils/getIconSize'
import { InputSuffix, InputSuffixProps } from '../InputSuffix'

type ErrorIconProps = Omit<InputSuffixProps, 'children'>

export const ErrorIcon = ({ disabled, inputSize, ...rest }: ErrorIconProps): ReactElement => (
  <InputSuffix disabled={disabled} inputSize={inputSize} {...rest}>
    <Icon size={getIconSize(inputSize)} icon="circleAlert" color={disabled ? Color.Grey300 : Color.Red700} />
  </InputSuffix>
)
